const VAGINAL_ANATOMY_OPTS = {
  WITH_VAGINA_IS_ABLE: 'with_vagina_is_able',
  WITH_VAGINA_IS_NOT_ABLE: 'with_vagina_not_able',
  NO_VAGINA: 'no_vagina',
};

const FILL_VAGINAL_ANATOMY_CONFIG = {
  with_vagina_is_able: {
    optionConfig: {
      optValue: VAGINAL_ANATOMY_OPTS.WITH_VAGINA_IS_ABLE,
      optLabel: 'onboardingbloom_answer_vaginal_anatomy_able_insert_sensor',
    },
  },
  with_vagina_not_able: {
    optionConfig: {
      optValue: VAGINAL_ANATOMY_OPTS.WITH_VAGINA_IS_NOT_ABLE,
      optLabel: 'onboardingbloom_answer_vaginal_anatomy_not_able_insert_sensor',
    },
  },
  no_vagina: {
    optionConfig: {
      optValue: VAGINAL_ANATOMY_OPTS.NO_VAGINA,
      optLabel: 'onboardingbloom_answer_not_able_inser_sensor',
    },
  },
};

const vaginalOpts = Object.values(FILL_VAGINAL_ANATOMY_CONFIG).map(vaginalOpt => vaginalOpt.optionConfig);

export { VAGINAL_ANATOMY_OPTS, FILL_VAGINAL_ANATOMY_CONFIG, vaginalOpts };
